import { create } from 'zustand'

interface UIStore {
  profileOpen: boolean
  encounterBountyId: string | null
  toasts: Toast[]
  setProfileOpen: (open: boolean) => void
  openEncounter: (bountyId: string) => void
  closeEncounter: () => void
  addToast: (toast: Omit<Toast, 'id'>) => void
  removeToast: (id: string) => void
}

interface Toast {
  id: string
  message: string
  type: 'success' | 'error' | 'info'
}

export const useUIStore = create<UIStore>((set) => ({
  profileOpen: false,
  encounterBountyId: null,
  toasts: [],

  setProfileOpen: (open) => set({ profileOpen: open }),

  openEncounter: (bountyId) => set({ encounterBountyId: bountyId }),
  closeEncounter: () => set({ encounterBountyId: null }),

  addToast: (toast) =>
    set((s) => ({
      toasts: [...s.toasts, { ...toast, id: crypto.randomUUID() }],
    })),
  removeToast: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}))
